import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const TabTitle = styled("span")(() => ({
  color: colors.gray600,
  font: "600 16px Manrope",
  lineHeight: "24px",
  paddingBottom: "24px",
  letterSpacing: "0.15px",
}));

export const AccountLogoWrapper = styled(Grid)(() => ({
  paddingLeft: "40px",

  "@media (max-width: 599px)": {
    padding: "40px 0",
  },
}));

export const UploadLogoInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  font: "400 14px Manrope",
  color: colors.gray500,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const UploadLogoInfoTitle = styled("div")(() => ({
  color: colors.gray600,
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const UploadIcon = styled("img")(() => ({
  padding: "8px",
}));

export const UploadLogoWrapper = styled("label")(() => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "12px",
  gap: "12px",
  borderRadius: "12px",
  border: `1px dashed ${colors.gray300}`,
}));

export const ButtonsWrapper = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "flex-end",
  padding: "16px",
  borderTop: `1px solid ${colors.gray200}`,
  position: "absolute",
  bottom: 0,
  left: 0,
}));
